import { useEffect, useState } from "react"
import { useParams, useNavigate, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { Box, Text } from "@chakra-ui/react"
import { FaTruck } from "react-icons/fa"
import useStore from "../../../store"
import { colors } from "../../../utilities/colors"
import { Widget, WidgetHeader, WidgetBody } from "../../ui/Widget"
import CreateQuote from "../Quotes/CreateQuote"
import QuoteRow from "../Quotes/QuoteRow"

export default function CarpoolUnitPage() {
  const { unitId } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation()
  const {
    fetchUnit,
    unit,
    unitFetching,
    getCarpoolQuotesForUnit,
    unitQuotes,
    unitQuotesFetching,
  } = useStore()
  const [createQuoteOpen, setCreateQuoteOpen] = useState(false)

  useEffect(() => {
    fetchUnit(unitId)
    getCarpoolQuotesForUnit(unitId)
  }, [])

  useEffect(() => {
    if (!unitFetching && unit?.errors) {
      navigate('/not-found')
    }
  }, [unitFetching])

  useEffect(() => {
    if (location.state?.autoOpenQuote) {
      setCreateQuoteOpen(true)
      navigate(location.pathname, { replace: true, state: null })
    }
  }, [])

  const handleQuoteCreated = () => {
    setCreateQuoteOpen(false)
    getCarpoolQuotesForUnit(unitId)
  }

  return (
    <>
      <Widget>
        <WidgetHeader
          title={
            unit?.attributes
              ? `${unit.attributes.year} ${unit.attributes.make} ${unit.attributes.model}`
              : t('Transport Quotes')
          }
          showSpinner={unitQuotesFetching}
          actionIcon={
            unit?.attributes && (
              <Box
                as="button"
                onClick={() => setCreateQuoteOpen(true)}
                display="flex"
                alignItems="center"
                gap={1}
                color={colors.green}
                fontSize="sm"
                fontWeight="medium"
                cursor="pointer"
                _hover={{ opacity: 0.8 }}
              >
                <FaTruck />
                <Text fontSize="xs">{t('New Quote')}</Text>
              </Box>
            )
          }
        />
        <WidgetBody isVisible={!unitFetching}>
          {unitQuotes.length === 0 ? (
            <Box textAlign="center" p={8} color={colors.grey300}>
              <FaTruck size={32} style={{ margin: '0 auto 12px' }} />
              <Text fontSize="md">{t('No transport quotes yet')}</Text>
              <Text fontSize="sm" mt={1} color={colors.grey}>
                {t('Create a new quote to get started')}
              </Text>
            </Box>
          ) : (
            unitQuotes.map((quote) => (
              <QuoteRow key={quote.id} quote={quote} />
            ))
          )}
        </WidgetBody>
      </Widget>

      {unit && (
        <CreateQuote
          units={[unit]}
          isOpen={createQuoteOpen}
          onClose={handleQuoteCreated}
        />
      )}
    </>
  )
}
